import * as automl from '@tensorflow/tfjs-automl';

let maskModel = null
let initialized = () => {
    return maskModel !== null
}
export const loadMaskModel = async (maskModelPath) => {
    maskModel = await automl.loadImageClassification(`${maskModelPath}/mask/model.json`);
}

const canvas = document.createElement('canvas');

export const detectFaceMask = async function (input, detection) {
    // Create a list to store the results

    try {

        // Create an image tensor from the detected face

        let box = detection.detection.box
        console.time("detectMask")
        let faceCanvas = getCroppedImageData(input, box.left, box.top, box.width, box.height, canvas);
        const predictions = await maskModel.classify(faceCanvas);
        //    console.log("predictions", predictions)
        detection.mask = predictions[0].prob
        detection.noMask = predictions[1].prob
        console.timeEnd("detectMask")


    } catch (e) {
        console.log("Error detectFaceMask", e)
        throw e
    }

}

function getCroppedImageData(input, x, y, width, height, canvas) {
    // create a canvas
    canvas.width = input.width;
    canvas.height = input.height;

    let context = canvas.getContext('2d');

    canvas.width = width;
    canvas.height = height;

    // draw the video frame to the canvas
    context.drawImage(input, x, y, width, height, 0, 0, width, height);

    return canvas
}
